module.exports = __webpack_public_path__ + "static/media/sting-bg.87f101e8.jpg";